import React from 'react';
import { DiceResult } from '../DiceResult';
import { DiceType } from '../../types/RoomMode';
import { RollGroup } from '../../utils/roomClient/types';
import './styles.css';

interface PlayerProps {
    name: string;
    subtitle?: string;
    lastRoll?: { chains: number[][]; difficulty?: number | null; diceType?: DiceType | null; rollGroups?: RollGroup[] | null; timestamp?: number } | null;
    dark?: boolean;
    rollUpdated?: boolean;
}

const RoomPlayer: React.FC<PlayerProps> = ({ name, subtitle, lastRoll, dark = false, rollUpdated = false }) => {
    const borderColor = dark ? 'rgba(255,255,255,.14)' : '#eee';
    const mutedColor = dark ? '#c8d3e2' : '#666';

    return (
        <div
            className={`room-player ${rollUpdated ? 'roll-updated' : ''}`.trim()}
            style={{ padding: 10, borderBottom: `1px solid ${borderColor}` }}
        >
            <div style={{ fontWeight: 700 }}>{name}</div>
            {subtitle ? (
                <div style={{ color: mutedColor, marginTop: 4, fontSize: '0.76rem' }}>{subtitle}</div>
            ) : null}

            {lastRoll?.chains ? (
                <div style={{ marginTop: 6 }}>
                    <DiceResult
                        chains={lastRoll.chains}
                        difficulty={lastRoll.diceType ? undefined : (lastRoll.difficulty ?? undefined)}
                        diceType={lastRoll.diceType ?? undefined}
                        rollGroups={lastRoll.rollGroups ?? undefined}
                    />
                </div>
            ) : (
                <div style={{ color: mutedColor, marginTop: 6 }}>Sin tiradas aún</div>
            )}
        </div>
    );
};

export default RoomPlayer;
